import * as React from 'react';
import styled from 'styled-components';


interface TitleProps {
  level?: number;
  children: React.ReactNode;
}

const TitleStyle = ({ level = 3, children }: TitleProps) => (
  <Title level={level}>
    {children}
  </Title>
)


export default TitleStyle;


interface StyleProps {
  level: number;
}

const Title = styled.h2<StyleProps>`
  font-size: ${p => {
    let size = '';
    switch(p.level) {
      case 1: return size = '32px';
      case 2: return size = '26px';
      case 4: return size = '14px';
      case 5: return size = '12px';
      case 3:
      default: return size = '20px';
    }
    return size;
  }};
  line-height: ${p => {
    let line = '';
    switch(p.level) {
      case 1: return line = '50px';
      case 2: return line = '30px';
      case 4: return line = '22px';
      case 5: return line = '18px';
      case 3:
      default : return line = '28px';
    }
    return line;
  }};
`;


// WEBPACK FOOTER //
// ./src/styles/ui/Title.tsx